import { render, staticRenderFns } from "./StatsEdulabApp.vue?vue&type=template&id=e71b8d9e&"
import script from "./StatsEdulabApp.vue?vue&type=script&lang=js&"
export * from "./StatsEdulabApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports